import { BaseClient } from '../base-client';
import type { Company } from './types';

export class CompanyClient extends BaseClient {
  /** The caller's own company profile (name + email domains). */
  get(): Promise<{ company: Company | null }> {
    return this.request('/api/company');
  }

  /**
   * Download a CSV of the tenant's login events over the last 30 days.
   * Returns the Blob plus the server-suggested filename from
   * Content-Disposition.
   */
  exportLoginHistoryCsv(signal?: AbortSignal): Promise<{ blob: Blob; filename: string | null }> {
    return this.requestBlob('/api/company/login-history/export', { signal });
  }
}
